<template>
  <div id="app">
    <commonHead/>

    <div class="page-box">
      <div class="first-row-box">
        <!-- 首行主新闻轮播图 -->
        <div class="main-swiper-box">
          <swiper ref="mainSwiper" :options="mainSwiperOptions">
            <swiper-slide v-for="(item,ind) in mainSwiperData" :key="ind">
              <a :href="`./DynamicDetail.html?id=${item.id}`" target="_blank">
                <img :src="item.image_list[0] || ''" alt="" />
                <div class="main-swiper-title">
                  <p class="main-swiper-title-text">{{ item.title }}</p>
                  <p class="main-swiper-title-desc">{{ item.summary }}</p>
                </div>
              </a>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        
        <!-- 首行右侧新闻列表 -->
        <div class="main-news-box">
          <a href="javascript:void(0)"  @click="jumpDetail(item.first_type,item.id)" class="main-news-cell" :class="{'first-main-news-cell' : ind===0}" v-for="(item,ind) in mainNewsList" :key="ind">
            <p class="main-news-title">{{ item.title }}</p>
            <p class="main-news-desc">{{ formatDesc(item.summary) }}</p>
          </a>
        </div>
      </div>

      <div class="bottom-wrap">
        <div class="bottom-left-wrap">
          <commonBlock :rmsId="3618533813" :pageSize="4" :blockName="'动态'" :type="'dt'"/>
          <commonBlock :rmsId="3618533166" :pageSize="4" :blockName="'课堂'" :type="'kt'"/>
        </div>


        <div class="bottom-right-wrap">
          <div class="right-common-block">
            <div class="right-common-title">
              投教活动
            </div>
            <div class="right-tjhd-wrap">
              <a class="tjhd-cell" v-for="(item,index) in tjhdList" :key="index" href="javascript:void(0)"  @click="jumpDetail(item.first_type,item.id)">
                <img :src="item.image_list[0]" alt="" />
                <p class="tjhd-cell-title">{{ item.title }}</p>
              </a>
            </div>
          </div>
          <div class="right-common-block">
            <div class="right-common-title">
              互动
            </div>
            <div class="right-qa-wrap">
              <div class="qa-cell" v-for="(item,index) in qaList" :key="index" :data-id="item.qa_id">
                <a class="qa-cell-title" :href="'./QADetail.html?id='+item.qa_id" target="_blank">{{ item.qa_info }}</a>
                <div class="flex-wrapper answer-wrap" v-if="item.reply_info && item.reply_info.reply_info">
                  <img src="../../common/img/answer.png" alt="">
                  <p class="qa-cell-content">
                    {{item.reply_info.reply_info}}
                    <a :href="'./QADetail.html?id='+item.qa_id" target="_blank">详细回答>></a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="right-common-block">
            <div class="right-common-title">
              模拟
            </div>
            <a href="./Simulation.html" class="right-ad-wrap">
              <img src="../../common/img/ad.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>

    <commonFooter/>
  </div>
</template>

<script>
import './index.less'
import commonHead from '../../components/head'
import commonFooter from '../../components/footer'
import commonBlock from './components/commonBlock'
import { getNewsList, getQaList } from '../../service/api' 
import UTILS from '../../common/utils'

export default {
  components: {
    commonHead,
    commonFooter,
    commonBlock,
  },
  name: 'app',
  computed: {
    swiper() {
      return this.$refs.mainSwiper.$swiper
    }
  },
  data(){
    return{
      mainSwiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        observer:true,
        loop: true,
        autoplay:{
          disableOnInteraction: false,
        }
        // Some Swiper option/callback...
      },
      mainSwiperData:[],
      mainNewsList:[],
      tjhdList:[],
      qaList:[],
    }
  },
  mounted() {
    // 获取首屏焦点图轮播
    getNewsList({
      api_type: 3618533811,
      page_size: 6,
      page_num: 1
    }).then(res => {
      this.mainSwiperData = res.data.data.data_list
    })

    // 获取首屏右侧要闻动态
    getNewsList({
      api_type: 3618533812,
      page_size: 5,
      page_num: 1
    }).then(res => {
      this.mainNewsList = res.data.data.data_list
    })

    // 获取投教活动
    getNewsList({
      api_type: 3618533814,
      page_size: 3,
      page_num: 1
    }).then(res => {
      this.tjhdList = res.data.data.data_list
    })

    // 获取互动
    getQaList({
      page_size: 3,
      page_num: 1
    }).then(res => {
      this.qaList = res.data.data.data_list
    })
  },
  methods:{
    formatDesc(str){
      return `${str.substring(0,50)}...`
    },
    jumpDetail(type,id){
      UTILS.fixJumpDetail(type,id)
    }
  }
}
</script>

